import React from 'react';

import { ReferentielUsesDto } from 'lib_api/lib/api/gen';

import { buildUsesInDossierMessage } from '../../Modals/ModalDesactivation/utils';

interface UsesEtatProps {
  uses: ReferentielUsesDto;
}

function UsesEtat({ uses }: UsesEtatProps): React.ReactElement {
  const listDossierId = uses.searchDossierResult?.listDossierId ?? [];
  return (
    <ul>
      {listDossierId.length > 0 && (
        <li>
          Cet état est utilisé dans les dossiers{' '}
          {buildUsesInDossierMessage(uses.searchDossierResult)}
        </li>
      )}
    </ul>
  );
}

export default UsesEtat;
